export const BANCARIO_PATTERN = "00000.00000 00000.000000 00000.000000 0 00000000000000";

export const ARRECADACAO_PATTERN = "00000000000-0 00000000000-0 00000000000-0 00000000000-0";
